<template>
    <v-dialog :value="value" max-width="360" persistent @input="$emit('input', $event)">
        <v-card class="confirm-dialog">
            <v-card-title class="text-subtitle-1 font-weight-bold">
                <v-icon :color="color" class="mr-2">{{ icon }}</v-icon>{{ title }}
            </v-card-title>
            <v-card-text v-if="text" class="text-body-2">{{ text }}</v-card-text>
            <v-card-actions class="pb-4 px-4">
                <v-btn text large class="flex-grow-1" @click="$emit('input', false)">
                    Cancel
                </v-btn>
                <v-btn depressed large class="flex-grow-1 white--text" :color="color" :loading="loading" @click="$emit('confirm')">
                    {{ confirmText }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    // Small confirmation dialog: v-model controls visibility, emits `confirm` on the main button
    export default {
        name: 'ConfirmDialog',
        props: {
            value: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                required: true
            },
            text: {
                type: String,
                default: null
            },
            confirmText: {
                type: String,
                default: 'Confirm'
            },
            color: {
                type: String,
                default: 'red darken-1'
            },
            icon: {
                type: String,
                default: 'mdi-alert-outline'
            },
            loading: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped>
    .confirm-dialog .v-btn {
        text-transform: none;
        letter-spacing: normal;
    }
</style>
